import animalService from "../services/animals-v2";
import IUploadXlsRequest from "../services/animals-v2/interfaces/request/IUploadXlsRequest";
import { useTranslate } from "./useTranslate";

const ERROR_TYPES: Record<string, string> = {
  "Sheet data not found": "Dados da planilha não encontrados",
};

const useAnimal = () => {
  const { translate } = useTranslate();

  const uploadXls = async (values: IUploadXlsRequest) => {
    // eslint-disable-next-line no-useless-catch
    try {
      const { data } = await animalService.uploadXls(values);
      if (data.resultError && data.resultError.length > 0) {
        const errors = data.resultError.map((item) => {
          const animal = item.number_identifier;
          const fields = item.error.map((item) => item.field?.replace("/", ""));
          return { animal, fields };
        });

        const message = errors.reduce((acc: any, cv) => {
          acc.push(
            `${translate("animals.fab_label_1")}: ${cv.animal} | ${translate(
              "animals.invalid_fields"
            )}: ${cv.fields?.join(", ")}`
          );
          return acc;
        }, []);

        throw new Error(JSON.stringify(message));
      }

      const error = data?.error;
      if (error) throw new Error(JSON.stringify([ERROR_TYPES[error]]));
    } catch (error: any) {
      throw error;
    }
  };

  const downloadXls = async () => {
    try {
      const { data } = await animalService.downloadXls();
      console.log({ data });
    } catch (error: any) {
      console.log(error);
    }
  };

  return { uploadXls, downloadXls };
};

export default useAnimal;
